export interface ValidationError {
    errorKey: string;
    errorMessage: string;
    errorVisible?: boolean;
}
